/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "a466bb06f56dc56d0b99bbff82855e65a80bc999";
